import React from 'react';
import { observer, inject } from 'mobx-react';
import List from './AppDetailList';
import styles from './AppDetailList.less';

@inject('deviceInfoAppStore', 'deviceInfoStore')
@observer
class Tab3 extends React.Component {
  componentDidMount() {
    const { deviceId } = this.props.deviceInfoStore;
    this.props.deviceInfoAppStore.loadAppDetail(deviceId);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.deviceInfoStore.deviceId) {
      const deviceId = nextProps.deviceInfoStore.deviceId;
      this.props.deviceInfoAppStore.loadAppDetail(deviceId);
    }
  }
  render() {
    const { deviceAppDetail } = this.props.deviceInfoAppStore;
    return (
      <div className={styles.appDetailListContainer}>
        {deviceAppDetail.map((item, index) => (
          <List key={index} BasicInfo={item} />
        ))}
      </div>
    );
  }
}
export default Tab3;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceApp.js